/**
 * @todo BE typo 'childrens'
 * @todo ts
 */
export function flattenTags(tags) {
  return tags.reduce((result, tag) => {
    result.push(tag);
    if (tag.childrens && tag.childrens.length) {
      const flattenChildrens = flattenTags(tag.childrens);
      result = result.concat(flattenChildrens);
    }
    return result;
  }, []);
}
